import { headers, parseJSON } from '../apiUtils';

export function fetchCustomerEmails_() {
    return fetch('/api/HiddenEndpoints/CustomerEmail', {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function setCustomerEmails_(emails) {
    return fetch('/api/HiddenEndpoints/CustomerEmail', {
        headers: headers(),
        method: 'POST',
        body: JSON.stringify(emails)
    }).then(parseJSON);
}
